<template>
    <UBadge :color="meta.color" :label="meta.label" variant="subtle" />
</template>

<script setup lang="ts">
import { LOT_STATUS_META } from '~/types/fieldPost'

const props = defineProps<{
    status: keyof typeof LOT_STATUS_META
}>()

const meta = computed(() => LOT_STATUS_META[props.status])
</script>
